"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const NumberFormatStyled = (0, _styledComponents.default)(_reactNumberFormat.default).withConfig({
  displayName: "Number__NumberFormatStyled",
  componentId: "design-system__sc-1xgueao-0"
})(["font-family:", ";font-size:", ";color:", ";"], _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.black);

const Number = _ref => {
  let {
    value,
    minDecimals
  } = _ref;

  const displayCents = () => {
    if (minDecimals) return minDecimals;
    if (value < 1000) return 2;
    return 0;
  };

  return /*#__PURE__*/_react.default.createElement(NumberFormatStyled, {
    value: value,
    displayType: "text",
    thousandSeparator: true,
    decimalScale: displayCents()
  });
};

Number.propTypes = {
  value: _propTypes.default.number.isRequired,
  minDecimals: _propTypes.default.number
};
Number.defaultProps = {
  minDecimals: undefined
};
var _default = Number;
exports.default = _default;